import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AuthStore } from '../store/auth.store';

export const authGuard: CanActivateFn = (_, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  return authStore.waitForAuthState().pipe(
    map((isAuthenticated) => {
      if (isAuthenticated) return true;

      void router.navigate(['/auth/login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }),
  );
};
